import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import moment from 'moment';
import { format, parseISO, fromUnixTime, formatDistanceToNow } from 'date-fns';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { Link } from 'react-router-dom';

import mixpanel from 'mixpanel-browser';

// Firebase
import { db } from '../../config/firebase-config';
import { collection, getDocs, getDoc, doc, query, where } from 'firebase/firestore';

// Redux
import { connect } from 'react-redux';


// Actions
import { addLike_Review, deleteReview } from '../../actions/postActions';
import { getUserById } from '../../actions/authActions';
import { createChat, addMessage  } from '../../actions/chatActions';
import { toggleAuthModal } from '../../actions/navActions';
import { setAlert } from '../../actions/alertActions';

// components - material UI
import { Avatar, Button } from '@material-ui/core';
import DefaultAvatar from 'react-avatar';
import Post from '../Post/Post';
import Tag from '../common/Tag';

import ImageBlock from '../common/ImageBlock';

// Icons - material UI
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import RepeatIcon from '@material-ui/icons/Repeat';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import LinkIcon from '@material-ui/icons/Link';
import CheckIcon from '@material-ui/icons/Check';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import PauseIcon from '@material-ui/icons/Pause';
import LocalMallOutlinedIcon from '@material-ui/icons/LocalMallOutlined';
import LinkOutlinedIcon from '@material-ui/icons/LinkOutlined';
import MailIcon from '@material-ui/icons/Mail';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';

// Modal
import Modal from '../modal/Modal';
import ModalContainer from '../modal/ModalContainer';

// DraftJS
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { Fragment } from 'react';
import Verification_Badge from '../common/Verification_Badge';

const Detail = ({
        post,
        auth,
        ad,
        nav: {
            website,
            website_loading
        },
        setAlert,
        addLike_Review,
        deleteReview,
        getUserById,
        createChat,
        addMessage,
        toggleAuthModal,
        toggleCommentModal,
        image,
        history,
        isTablet,
        commentList,
        likeList,
        setScrollDirection,
        setOldScrollY,
        oldScrollY,
        safeTrackPostAnalytics
    }) => {
        
        // Tracks the like status of post
        const [liked, setLiked] = useState(false);
        // Flag for checking if like is properly updated
        const [checkLike, setCheckLike] = useState(false);

        // Flag for checking if group's name should display as author of post
        const [showGroupName, setShowGroupName] = useState(false);

        // --- Convert DraftJS text to HTML text

        // Tracks whether the text has been converted
        const [gotText, setGotText] = useState(false);
        // Stores the converted text
        const [textState, setTextState] = useState(null);
        const [rawTextState, setRawTextState] = useState(null);

        // Check if post has image - for font size reasons
        const [hasImg, setHasImg] = useState(false);
        // Flag for checking if hasImg is properly updated
        const [checkHasImg, setCheckHasImg] = useState(false);
        const [imgHeight, setImgHeight] = useState(200);

        // Toggle Dropdwon
        const [dropdown, setDropdown] = useState(false);
        const [shareDropdown, setShareDropdown] = useState(false);

        // Stores the height of a toggle menu
        const [menuHeight, setMenuHeight] = useState(null);

        // Modal toggles
        const [deleteModal, setDeleteModal] = useState(false);
        const [messageModal, setMessageModal] = useState(false);

        // Tracks the status of copying
        const [copied, setCopied] = useState(false);
        
        // Controls the visibility of a copied modal
        const [copiedModal, setCopiedModal] = useState(false);

        // --- Parent Posts for comments ------
        const [parentPosts, setParentPosts] = useState([]);
        const [gotParentPosts, setGotParentPosts] = useState(false);

        const [gotTopNav, setGotTopNav] = useState(false);

        // --- END Parent Posts for comments


        // -- Text Truncation Functions ---
        
        // is text expanded?
        const [isExpanded, setIsExpanded] = useState(true);
        const CHARACTER_LIMIT = 200;
        const [shouldTruncate, setShouldTruncate] = useState(false);
        
        // -- END: Text Truncation Functions ---

        useEffect(() => {

            // Set a timeout to hide the copied modal after 2 seconds
            setTimeout(() => {
                setCopiedModal(false);
            }, 2000);

        }, [copiedModal]);

        useEffect(() => {

            // Set a timeout to hide the share dropdown and reset the copied flag after 1 second
            setTimeout(() => {
                setShareDropdown(false);
                setCopied(false);
            }, 1000);
        }, [copied]);

        const handleLike = (reviewId) => {

            // If the user is authenticated, add a like to the post and toggle the liked state
            if(auth.user) {
                addLike_Review({ reviewId, fromUserData: auth.user, reviewData: post });
                setLiked(!liked);
            } else {

                // If the user is not authenticated, fetch the user by ID and toggle the authentication modal
                getUserById(post.user._id);
                toggleAuthModal('like');
            }
        }

        // Redirect to the create comment page for the current post
        const redirectComment = () => {
            window.location.href = `/create/comment/${post._id}?parentType=review`;
        }

        // Copy Modal logic

        const toggleCopiedModal = () => {

            // --- Close other dropdowns and set the copied alert message

            setDropdown(false);
            setShareDropdown(false);
            
            // setCopiedModal(!copiedModal);
            setAlert('Copied to clipboard', `${!auth.loading && auth.isAuthenticated ? 'okay' : 'success'}`);
        }

        // Delete Modal logic

        const toggleDeleteModal = () => {

            // Close other dropdowns and toggle the delete modal
            setDropdown(false)
            setDeleteModal(!deleteModal);
        }
        
        const handleDelete = () => {
            if(post) {
                let stored_id = post._id

                // Call the deleteReview function to delete the review
                deleteReview(post._id);

                // Mixpanel event tracking for deleting a review
                if (process.env.NODE_ENV === 'production') {
                    mixpanel.track("Delete Review", {
                        "Review ID": `${stored_id}`
                    });
                }
            }
    
            setDeleteModal(false);
        }

        const handleProfileVisit = async () => {
            console.log('About to Visit Profile..');

            window.location.href = `/user/${post.user._id}`;
        }

        // Message Logic

        const toggleMessageModal = () => {

            // Close other dropdowns
            setDropdown(false);
            setShareDropdown(false);

            // Get user by ID if the message modal is not currently open
            if(!messageModal) getUserById(post.user._id);
            
            setMessageModal(!messageModal);
        }
    
        const continueMessage = () => {
            if(auth.user) {

                // If the user is authenticated, create a new chat
                createNewChat();
            } else {

                // If the user is not authenticated, close the message modal and show the authentication modal
                setMessageModal(false);
                toggleAuthModal('message');
            }
        }

        const createNewChat = async () => {
            const chatsCollectionRef = collection(db, "chats");
    
            // Check if chat with 2 users already exists by chat ID
    
            console.log('CHECK USER CHAT HERE')

            try {
                // Query chats where the current user is the from_user and the modal user is the to_user
                const chatsQuery = query(chatsCollectionRef, where("from_user._id", "==", auth.user._id), where("to_user._id", "==", auth.modalUser._id));

                // Query chats where the modal user is the from_user and the current user is the to_user
                const otherChatsQuery = query(chatsCollectionRef, where("to_user._id", "==", auth.user._id), where("from_user._id", "==", auth.modalUser._id));
        
                // Query chats where the current user is the from_user and the modal user is the to_user
                const chatsSnapshot = await getDocs(chatsQuery);

                // Map the document snapshots to an array of chat objects, including the document ID
                const chats = chatsSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
        
                // Query chats where the modal user is the from_user and the current user is the to_user
                const otherChatsSnapshot = await getDocs(otherChatsQuery);

                // Map the document snapshots to an array of chat objects, including the document ID
                const otherChats = otherChatsSnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

                let chatRoomId;
        
                // If array length > 0 then there is already existing chat & redirect instead
            
                if(chats.length > 0) {

                    // -- Share post with user ---

                    // Send a message with postID attached
                    console.log('Sharing post...')
                    await addMessage({ formData: { postId: post._id }, imgData: null, imgDimensions: null, chatId: chats[0]._id, userObj: auth.user, notify_toId: post.user._id, website });

                    // -- END: Share post with user ---
                } else if (otherChats.length > 0) {

                    // -- Share post with user ---

                    // Send a message with postID attached
                    console.log('Sharing post...')
                    await addMessage({ formData: { postId: post._id }, imgData: null, imgDimensions: null, chatId: otherChats[0]._id, userObj: auth.user, notify_toId: post.user._id, website });

                    // -- END: Share post with user ---
                } else {

                    // Create a new chat if no existing chat is found
                    chatRoomId = await createChat(auth.modalUser, auth.user, post._id);

                    // -- Share post with user ---

                    // Send a message with postID attached
                    console.log('Sharing post...')
                    await addMessage({ formData: { postId: post._id }, imgData: null, imgDimensions: null, chatId: chatRoomId, userObj: auth.user, notify_toId: post.user._id, website });

                    // -- END: Share post with user ---
                }


                // -- Redirect to chat page --

                if(chats.length > 0) {
                    window.location.href = `/messages/${chats[0]._id}`;
                } else if (otherChats.length > 0) {
                    window.location.href = `/messages/${otherChats[0]._id}`;
                } else {
                    // Redirect to the chat page with the newly created chat room ID
                    if(chatRoomId) {
                        window.location.href = `/messages/${chatRoomId}`;
                    } else {
                        // Fallback: If something goes wrong go to messages page
                        window.location.href = `/messages`;
                    }
                }

                // -- END: Redirect to chat page --
        
                setMessageModal(!messageModal);
                
                console.log('SHOULD BE DONE CREATING');
                
            } catch (error) {
                console.log('Failed to create new chat');
                // console.log(error);
                setAlert('Unable to start conversation', 'danger');
            }
        }

        // End

        // -- Text Truncation Functions ---
    
        // Helper function
        const getPlainText = (html) => {
            const div = document.createElement('div');
            div.innerHTML = html;
            return div.textContent || div.innerText || '';
        };

        // -- END: Text Truncation Functions ---

        const capitalizeFirstLetter =(string) => {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        const detect_Links_phoneNumbers_Addresses =(string) => {
            // Regex to match URLs
            const urlRegex = /(?<![@\w])(?:https?:\/\/|www\.)?(?:[a-z0-9-]+\.)+[a-z]{2,}(?:\/[^\s<]*)?(?![\w@])/gi;

            // Regex for phone numbers (basic US-style, adjust if needed)
            // Matches formats like: 123-456-7890, (123) 456-7890, 1234567890, +1 123 456 7890
            const phoneRegex = /(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?){1,2}\d{4}/g;

            // Regex for addresses (US-style)
            // Matches things like: 123 Main St | 456 Elm Street, Springfield | 789 Broadway Ave, Apt 5, New York
            // TODO: Use a location keyword list to improve detection (i.e. city names, states, countries)
            const addressRegex = /\d{1,5}\s[\w\s]{1,30}\s(?:Street|St|Avenue|Ave|Boulevard|Blvd|Road|Rd|Lane|Ln|Drive|Dr|Court|Ct|Way|Wy|Plaza|Circle|Ct|Terrace|Ter|Trail|Trl)\b(?:,\s?[\w\s]+)*/gi;

            // 1st wrap URLs with <a> tags
            let temp_result = string.replace(urlRegex, (url) => {

                // If the URL already starts with http:// or https://, leave it
                // Otherwise, prepend http://
                // (purpose: makes sure the link redirects properly)
                const safe_url = /^(https?:\/\/)/i.test(url) ? url : `http://${url}`;

                return `<a href="${safe_url}" class='hoverable_link' target="_blank" rel="noopener noreferrer">${url}</a>`;
            });

            // 2nd replace phone numbers
            temp_result = temp_result.replace(phoneRegex, (phone) => {
                // Remove spaces/dashes for href
                const tel = phone.replace(/[-.\s()]/g, "");
                return `<a href="sms:${tel}" class='hoverable_link'>${phone}</a>`;
            });

            // 3rd replace addresses with Google Maps links
            temp_result = temp_result.replace(addressRegex, (address) => {
                const href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
                return `<a href="${href}" class='hoverable_link' target="_blank" rel="noopener noreferrer">${address}</a>`;
            });

            return temp_result;
        }
    
        // Check if the authenticated user exists and the checkLike flag is false
        if(auth.user && !checkLike) {

            // Filter the likes array of the post to check if the authenticated user has liked the post
            if(post.likes.filter(like => like.user._id.toString() === auth.user._id).length > 0){

                // If the authenticated user has liked the post, set the liked state to true
                setLiked(true);
            }
            
            // Set the checkLike flag to true to indicate that the check has been performed
            setCheckLike(true);
        }  

        // Converts the DraftJS text to HTML and sets the converted text
        useEffect(() => {
            if (post && !gotText) {
                let unRawState;
                let unRawDescription;

                if(post.text) {
                    try {
                        // Convert stringified DraftJS JSON to a raw JS object
                        const rawBlocksData = JSON.parse(post.text);

                        // Extract just the array of text blocks
                        if (rawBlocksData && Array.isArray(rawBlocksData.blocks)) {
                            unRawState = EditorState.createWithContent(
                                convertFromRaw(rawBlocksData)
                            );

                            unRawDescription = draftToHtml(convertToRaw(unRawState.getCurrentContent()));
                        } else {
                            unRawDescription = post.text;
                        }

                        // -- Detect URLs & Phone #'s in text ---

                        unRawDescription = detect_Links_phoneNumbers_Addresses(unRawDescription);
                        
                        // -- END: Detect URLs & Phone #'s in text ---

                        // -- Text Truncation Functions ---

                        // Check if truncation is needed
                        const plainText = getPlainText(unRawDescription);
                        const shouldTruncate_temp = plainText.length > CHARACTER_LIMIT;
                        const truncated_text = plainText.substring(0, CHARACTER_LIMIT) + '...';
                        setShouldTruncate(shouldTruncate_temp);

                        // -- END: Text Truncation Functions ---

                        setRawTextState(unRawDescription);

                        setTextState(detect_Links_phoneNumbers_Addresses(truncated_text));
                    } catch (error) {
                        const text_final = detect_Links_phoneNumbers_Addresses(post.text);
                        
                        setRawTextState(text_final);
                        setTextState(text_final);
                    }
                }
                
                // Marks that the text conversion has been performed
                setGotText(true);
            }
        }, [post, gotText]);

        // --- ImageKit (img optimization service) ---

        let optimized_post_avatar_path = null;

        if(post.user.img) {
            optimized_post_avatar_path = post.user.img.replace("https://firebasestorage.googleapis.com","https://ik.imagekit.io/pba3w2st28/");
        }

        let shareLink = `${website ? website.url : process.env.REACT_APP_DOMAIN}/review/${post._id}`;

        return (
            <Fragment>
                <div className="postPage">

                    {/* More Button - trigger dropdown */}
                    <div onClick={() => setDropdown(!dropdown)} className={`post__moreBtn`}>
                        <MoreHorizIcon />
                    </div>

                    {/* More btn Dropdown Menu */}
                    <div className={dropdown ? "edit-dropdown active" : "edit-dropdown"} style={{height: menuHeight}}>
                        <div className="menu">

                            {/* Copy Link Menu Item */}
                            <CopyToClipboard 
                                text={shareLink}
                                onCopy={toggleCopiedModal}
                            >
                                <div className="menu-item">
                                    {!copied ? (
                                        <Fragment>
                                            <LinkIcon />
                                            Copy link
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <CheckIcon />
                                            Copied!
                                        </Fragment>
                                    )}
                                </div>
                            </CopyToClipboard>

                            {auth.user && post.user._id !== auth.user._id && (
                                <div onClick={toggleMessageModal} className="menu-item">
                                    <MailIcon />
                                    Send Message
                                </div>
                            )}

                            {/* Delete Menu Item (shown only for authenticated user who created the post) */}
                            {auth.user && post.user._id === auth.user._id ? (
                                <Fragment>
                                    <div onClick={toggleDeleteModal} className="menu-item danger">
                                        <DeleteIcon />
                                        Delete
                                    </div>
                                </Fragment>
                            ) : null}
                        </div>
                    </div>

                    {/* Hidden Overlay for more btn dropdown */}
                    <div
                        className={`hidden-overlay ${dropdown ? "show" : ""}`}
                        onClick={() => setDropdown(!dropdown)}
                    />

                    {/* Detail Post Header - top */}
                    <div className="postPage__header">

                        {/* Display the user avatar - links to profile page */}
                        <div onClick={handleProfileVisit} className="postPage__avatar">

                            {optimized_post_avatar_path ? (
                                <Avatar src={optimized_post_avatar_path && optimized_post_avatar_path} />
                            ) : (
                                <DefaultAvatar name={showGroupName ? `${post.group.name}` : `${post.user.first_name} ${post.user.last_name}`} />
                            )}
                        </div>
                        <div className="postPage__headerText">
                            {/* Display name */}
                            <div style={{display: 'flex'}}>
                                <h3>
                                    <span onClick={handleProfileVisit} className='hover_underline'>
                                        <span>{post.username && post.username + ' '} </span>

                                        {/* Display the verified badge if the user is verified */}
                                        <span className="postPage__headerSpecial">
                                            <Verification_Badge user={post.user} />
                                        </span>
                                    </span>
                                </h3>
                            </div>
                            {(post.to_user?.username)&& (
                                <div className='replying_to_title'>
                                    Review for {' '}
        
                                    <a href={`/user/${post.to_user._id}`}>
                                        {post.to_user.first_name} {post.to_user.last_name && ' ' + post.to_user.last_name.charAt(0).toUpperCase()}.
                                    </a>
                                </div>
                            )}
                            <p>{formatDistanceToNow(post.date)} ago</p>
                        </div>
                    </div>

                    {/* Detail Post Body - bottom */}
                    <div className="postPage__body">

                        {/* Render the post text content */}
                        {textState !== null && (
                            <div className={`postPage__headerDescription ${hasImg ? 'withImgs' : ''} ${shouldTruncate ? 'shouldTruncate' : ''} `}>
                                {/* <p>{post.text ? post.text : null}</p> */}

                                {/* Render the converted HTML text description */}
                                {!isExpanded && shouldTruncate 
                                    ? <div className='break_long_words' dangerouslySetInnerHTML={{__html: textState}} /> 
                                    : <div className='break_long_words' dangerouslySetInnerHTML={{__html: rawTextState}} />}

                                {shouldTruncate && (
                                    <span 
                                        className='post_see_more_btn'
                                        onClick={() => setIsExpanded(!isExpanded)}
                                    >
                                        {isExpanded ? 'See less' : 'See more'}
                                    </span>
                                )}
                            </div>
                        )}

                        {/* Display the post images if available */}
                        <ImageBlock 
                            detailPost={post} 
                            setHasImg={setHasImg} 
                            setCheckHasImg={setCheckHasImg} 
                            checkHasImg={checkHasImg} 
                            setImgHeight={setImgHeight}
                        />

                        {hasImg && (
                            // Spacing Element
                            <div style={{height: `${imgHeight+20}px`}} />
                        )}
                        {/* Display the post timestamp */}
                        <div className="postPage__timeStamp">
                            <p>{format(post.date, "h:mm a")}</p>
                            <p>{format(post.date, "MMM do")}</p>
                        </div>

                        <div className="postPage__actions">
                            {auth.user && post.user._id !== auth.user_id ? (
                                <div className={liked ? "active" : "" } onClick={() => handleLike(post._id)}>

                                    {/* Like button */}
                                    <button className={liked ? "secondaryBtn post active" : "secondaryBtn post like" }>
                                        <div>

                                            {/* Render the like icon based on whether the post is liked */}
                                            {liked ? <FavoriteIcon fontSize="small" /> : <FavoriteBorderIcon fontSize="small" />}

                                            {/* Btn Text w/ like qty */}
                                            <span>{liked ? 'Liked!' : 'Like'} {post.likes.length > 0 && (
                                                <span style={liked ? {display:'none'}: {fontSize:'11px'}}>({post.likes.length})</span>
                                            )}</span>
                                        </div>
                                    </button>
                                </div>
                            ) : (
                                // Placeholder
                                <div></div>
                            )}

                            {auth.user && post.to_user._id === auth.user_id && (
                                <div>
                                    <button 
                                        onClick={() => {
                                            if(auth.user) {
                                                if(isTablet) {
                                                    redirectComment()
                                                } else {
                                                    toggleCommentModal()
                                                }
                                            } else {
                                                getUserById(post.user._id);
                                                toggleAuthModal('comment');
                                            }
                                        }}                   
                                        className="secondaryBtn post"
                                    >
                                        <div>
                                            {/* Btn Icon */}
                                            <ChatBubbleOutlineIcon fontSize="small" />
                                            {/* Btn Text */}
                                            <span>Comment</span>
                                        </div>
                                    </button>
                                </div>
                            )}
                            
                            <div style={{position: 'relative'}}>

                                {/* Share button */}
                                <button onClick={() => setShareDropdown(!shareDropdown)} className="secondaryBtn post share">
                                    <div>
                                        {/* Btn Icon */}
                                        <ShareIcon fontSize="small" />
                                        {/* Btn Text */}
                                        <span>Share</span>
                                    </div>
                                </button>

                                {/* Share btn Dropdown menu */}
                                <div className={shareDropdown ? "edit-dropdown active" : "edit-dropdown"} style={{height: menuHeight}}>
                                    <div className="menu">

                                        {/* Copy post link to clipboard */}
                                        <CopyToClipboard 
                                            text={shareLink}
                                            onCopy={toggleCopiedModal}
                                        >
                                            <div className="menu-item">
                                                {!copied ? (
                                                    <Fragment>
                                                        <LinkIcon />
                                                        Copy link
                                                    </Fragment>
                                                ) : (
                                                    <Fragment>
                                                        <CheckIcon />
                                                        Copied!
                                                    </Fragment>
                                                )}
                                            </div>
                                        </CopyToClipboard>
                                    </div>
                                </div>

                                {/* Hidden Overlay for share btn dropdown */}
                                <div
                                    className={`hidden-overlay ${shareDropdown ? "show" : ""}`}
                                    onClick={() => setShareDropdown(!shareDropdown)}
                                />
                            </div>
                        </div>

                    </div>
                </div>

                {/* Delete Post Modal */}
                <ModalContainer show={deleteModal} onClose={toggleDeleteModal}>
                    <Modal>

                        {/* Modal Title */}
                        <div>
                            <h2>Delete Review?</h2>
                        </div>

                        {/* Modal Description */}
                        <p>This can’t be undone and it will be removed from the user's profile.</p>

                        {/* Modal Actions */}
                        <Button 
                            onClick={handleDelete}
                            variant="outlined" 
                            className="sidebar__tweet danger"
                            fullWidth
                        >
                            Delete
                        </Button>
                        <Button 
                            onClick={toggleDeleteModal}
                            variant="outlined" 
                            className="sidebar__tweet ghost"
                            fullWidth
                        >
                            Cancel
                        </Button>
                    </Modal>
                </ModalContainer>

                {/* Create Message confirmation Modal */}  
                <ModalContainer show={messageModal} onClose={toggleMessageModal}>
                    <Modal>

                        {/* Modal Title */}
                        <div>
                            <h2>Start Conversation?</h2>
                        </div>

                        {/* Modal Description */}
                        <p>Start a private conversation with <b style={{color: '#333'}}>{post.username ? post.username : 'this person'}</b></p>
                        
                        {/* Modal Actions */}
                        <Button 
                            onClick={continueMessage}
                            variant="outlined" 
                            className="sidebar__tweet black"
                            fullWidth
                        >
                            Start Conversation
                        </Button>
                        <Button 
                            onClick={toggleMessageModal}
                            variant="outlined" 
                            className="sidebar__tweet ghost blackText"
                            fullWidth
                        >
                            Cancel
                        </Button>
                    </Modal>
                </ModalContainer>

                {/* Copied Link Modal */}
                <ModalContainer show={copiedModal} onClose={toggleCopiedModal} white>
                    <Modal border>

                        {/* Modal Title */}
                        <div>
                            <h2>Link Copied!</h2>
                        </div>

                        {/* Modal Description */}
                        <p>You can share this link with anyone.</p>
                        
                        {/* Modal Actions */}
                        <Button 
                            onClick={toggleCopiedModal}
                            variant="outlined" 
                            className="sidebar__tweet ghost"
                            fullWidth
                        >
                            Close
                        </Button>
                    </Modal>
                </ModalContainer>
            </Fragment>
        )
}

Detail.propTypes = {
    setAlert: PropTypes.func.isRequired, // Function prop to set an alert
    addLike_Review: PropTypes.func.isRequired, // Function prop to add a like to a post
    deleteReview: PropTypes.func.isRequired, // Function prop to delete a post
    getUserById: PropTypes.func.isRequired, // Function prop to retrieve user data by ID
    createChat: PropTypes.func.isRequired, // Function prop to create a chat conversation
    addMessage: PropTypes.func.isRequired,
    toggleAuthModal: PropTypes.func.isRequired, // Function prop to toggle the authentication modal
    auth: PropTypes.object.isRequired, // Object prop representing the authentication data for the user
    ad: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    
    // Mapping the auth state from the Redux store to the 'auth' prop
    auth: state.auth,
    ad: state.ad,
    nav: state.nav
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    setAlert, 
    addLike_Review, 
    deleteReview, 
    getUserById, 
    createChat, 
    addMessage,
    toggleAuthModal 
})(Detail);
